import { GALLERY } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="relative py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <Reveal>
          <Overline>Campus Life</Overline>
          <h2 className="ff-display text-4xl md:text-6xl tracking-tight text-ink max-w-xl leading-[1]">
            Moments from within our walls.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-ink/60 font-light max-w-xs">
            Learning, celebration, sport and stillness — a day in the life of a Bhakti Svarup student.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8 auto-rows-[220px] md:auto-rows-[260px]">
        {GALLERY.map((g, i) => (
          <Reveal key={i} delay={(i % 3) * 0.1} className={g.span}>
            <figure
              className={`group relative h-full w-full overflow-hidden border border-maroon/15 ${
                g.arch ? "rounded-t-[140px]" : ""
              }`}
            >
              <img
                src={g.src}
                alt={g.alt}
                className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
              />
              <figcaption className="absolute bottom-4 left-4 right-4 text-cream text-sm tracking-wide opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                {g.alt}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
